module.exports = __webpack_public_path__ + "public/img/horizontal_menu_logo_dark.81ce36ff.svg";